/* eslint-disable */
import { authHeader, revalidateToken, shouldRevalidateToken } from "./wp.auth.service";
import axios from "axios";
import { logoutUser } from "../helpers/authHelpers";

/**
 * The API Base
 */
const API_URL = process.env.REACT_APP_API_URL || ""; /* eslint-disable-line no-undef */

/**
 * The Axios Client Instance
 */
const client = axios.create({ baseURL: API_URL });

/**
 * A GraphQL Post Query Wrapper
 *
 * @param {query, variables} args The arguments to pass to the GraphQL server;
 * @returns
 */
 export const graphql = async (data, noHeaders = false, params = {}) => {

	if ( params.cacheId ) {
		try {
			const cachedRes = await client.get(`${lwc_cache_path}/${params.cacheId}.json?cb=` + new Date().getTime());

			if (
				cachedRes &&
				cachedRes.status === 200 &&
				cachedRes.headers['content-type'].search('application/json') === 0 &&
				! cachedRes.data.errors
			) {
				return cachedRes;
			}
			throw new Error('No cached JSON');
		} catch (error) {
			const cachedRes = await client.get(`/graphql?cacheId=${params.cacheId}`);

			if ( cachedRes && ! cachedRes.data.errors ) {
				return cachedRes;
			}
		}
	} else {

		if (!noHeaders && shouldRevalidateToken()) {
			const canRevalidate = await revalidateToken();
			if (!canRevalidate) {
				logoutUser();
			}
		}
	
		return client.post(
			`/graphql?${new URLSearchParams(params).toString()}`,
			data,
			{
				headers: noHeaders ? {} : authHeader()
			}
		).
			then((res) => {
	
				if (res.data.errors && res.data.errors[0]) {
					const { errors } = res.data;
					throw new Error(errors[0].message);
				}
				return res;
			});

	}
};